@import "../../scss";

.root {
  border-radius: 111px;
  height: var(--spacer-5);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  padding: 0 1rem;
  border: 2px solid var(--color-bright-green);
  text-decoration: none;
  cursor: pointer;
  line-height: 1;
  color: var(--color-cream);
  transition: all 0.2s ease;

  @include typo--button;

  @include media-breakpoint-down("md") {
    height: var(--spacer-4);
  }
}

.root--disabled,
.root:disabled {
  pointer-events: none;
  opacity: 0.7;
}

.root--large {
  height: 3.6rem;
  padding: 0 2rem;
  font-size: 1.3rem;

  @include media-breakpoint-down("sm") {
    height: var(--spacer-5);
    padding: 0 1rem;
    font-size: 1rem;
  }
}

.root:not(.root--icon-only) svg {
  margin-right: 0.5rem;
}

.root--icon-only {
  width: var(--spacer-5);
  padding: 0;

  @include media-breakpoint-down("md") {
    width: var(--spacer-4);
  }
}

// weird specifity bug with text colour on links
a.root--outline,
.root--outline {
  color: var(--color-bright-green);

  @include hover {
    background: var(--color-bright-green);
    color: var(--color-white);
    box-shadow: 0px 0px 6px var(--color-bright-green);
  }
}

.root--filled {
  background: var(--color-bright-green);
  color: var(--color-cream);

  @include hover {
    box-shadow: 0px 0px 6px var(--color-bright-green);
  }
}
